export default function createMarkerIcon(color) {
  return `https://static.gasbuddy.com/web/tracker/marker-${color}-sm.png`;
}
